/**
 * Phase 55 — Messenger FAB.
 *
 * Floating action button that lives in every ERP page's bottom-right
 * corner. Shows the unread badge and lazy-loads the full panel on
 * first click. Renders nothing for anonymous users.
 */
import React, { Suspense, lazy } from "react";
import { MessageCircle } from "lucide-react";
import { useMessenger } from "@/contexts/MessengerContext";

// Lazy — the panel + its heavy children (attachment previews, emoji
// grid, virtual scroll bits) only load once the operator opens
// Messenger for the first time.
const MessengerPanel = lazy(() => import("./MessengerPanel"));

export default function MessengerFAB() {
  const { open, unread, openPanel, closePanel } = useMessenger();
  return (
    <>
      <button
        type="button"
        data-testid="messenger-fab"
        onClick={openPanel}
        aria-label="Mesajlar"
        className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[70] w-14 h-14 rounded-full bg-[#0A0A0A] hover:bg-[#1c1c1c] text-white shadow-[0_10px_30px_rgba(0,0,0,0.35)] flex items-center justify-center transition-all active:scale-95"
      >
        <MessageCircle size={22} strokeWidth={1.8} className="text-[#C8A96A]" />
        {unread > 0 && (
          <span
            data-testid="messenger-unread-badge"
            className="absolute -top-1 -right-1 min-w-[22px] h-[22px] px-1.5 bg-red-600 text-white text-[11px] font-medium rounded-full flex items-center justify-center border-2 border-white"
          >
            {unread > 99 ? "99+" : unread}
          </span>
        )}
      </button>
      {open && (
        <Suspense fallback={null}>
          <MessengerPanel onClose={closePanel} />
        </Suspense>
      )}
    </>
  );
}
